(() => {
  if (window.CtSg) return;

  const KEY = 'ct-sg-unit';
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const readUnit = () => {
    try {
      return localStorage.getItem(KEY) === 'met' ? 'met' : 'imp';
    } catch (e) {
      return 'imp';
    }
  };

  const CtSg = {
    unit: readUnit(),

    setUnit(unit, silent) {
      this.unit = unit === 'met' ? 'met' : 'imp';
      document.documentElement.setAttribute('data-ct-unit', this.unit);
      try {
        localStorage.setItem(KEY, this.unit);
      } catch (e) {}
      this.syncUnitButtons();
      if (!silent) document.dispatchEvent(new CustomEvent('ct-sg:unit', { detail: { unit: this.unit } }));
    },

    syncUnitButtons() {
      document.querySelectorAll('[data-ct-unit-btn]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.ctUnitBtn === this.unit ? 'true' : 'false');
      });
    },

    publish(name, data) {
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, data || {});
        }
      } catch (e) {}
    },

    span(cls, text) {
      const el = document.createElement('span');
      el.className = cls;
      el.textContent = text;
      return el;
    },

    ftIn(inches) {
      let ft = Math.floor(inches / 12);
      let rest = Math.round(inches - ft * 12);
      if (rest === 12) {
        ft += 1;
        rest = 0;
      }
      return ft + "' " + rest + '"';
    },

    round1(n) {
      return Math.round(n * 10) / 10;
    },

    dual(imp, met) {
      const frag = document.createDocumentFragment();
      frag.append(this.span('u-imp', imp), this.span('u-met', met));
      return frag;
    },

    height(cm, inches) {
      const i = inches || cm / 2.54;
      return this.dual(this.ftIn(i), Math.round(cm) + ' cm');
    },

    width(cm) {
      return this.dual(this.round1(cm / 2.54) + ' in', this.round1(cm) + ' cm');
    },

    async addToCart(source, items) {
      if (typeof window.ctAddToCart === 'function') {
        const result = await window.ctAddToCart(source, items);
        this.openCart(result);
        return result;
      }

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      let ev = null;
      try {
        ev = await import('@shopify/events');
      } catch (e) {
        ev = null;
      }
      const Std = ev && ev.CartLinesUpdateEvent && typeof ev.CartLinesUpdateEvent.createPromise === 'function' ? ev.CartLinesUpdateEvent : null;
      const deferred = Std ? Std.createPromise() : null;
      if (Std) {
        source.dispatchEvent(new Std({
          action: 'add',
          context: 'product',
          lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
          promise: deferred.promise
        }));
      }

      try {
        const res = await fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: sectionIds.join(',') })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        const cart = await (await fetch(root() + 'cart.js')).json();
        const itemCount = items.reduce((n, i) => n + i.quantity, 0);

        if (Std) {
          deferred.resolve({
            cart: Std.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'ct-size-guide', sourceId: source.id, itemCount: itemCount, sections: data.sections, didError: false }
          });
        } else {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: source.id, data: { source: 'ct-size-guide', itemCount: itemCount, sections: data.sections } }
          }));
        }

        const result = { cart: cart, modern: !!Std };
        this.openCart(result);
        return result;
      } catch (err) {
        if (deferred) deferred.reject(err);
        throw err;
      }
    },

    openCart(result) {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.open === 'function' && !drawer.hasAttribute('open')) {
          try {
            drawer.open();
          } catch (e) {}
        }
        return;
      }
      if (!document.querySelector('cart-items-component')) window.location.href = root() + 'cart';
    },

    openChat(email) {
      const host = document.querySelector('inbox-online-store-chat');
      const shadow = host && host.shadowRoot;
      const btn = shadow && (shadow.querySelector('button[aria-controls]') || shadow.querySelector('button'));
      if (btn) {
        btn.click();
        this.publish('ct_size_guide_chat', { method: 'inbox' });
        return;
      }
      this.publish('ct_size_guide_chat', { method: 'email' });
      if (email) window.location.href = 'mailto:' + email;
    }
  };

  window.CtSg = CtSg;
  document.documentElement.setAttribute('data-ct-unit', CtSg.unit);

  document.addEventListener('click', (event) => {
    const unitBtn = event.target.closest('[data-ct-unit-btn]');
    if (unitBtn) {
      CtSg.setUnit(unitBtn.dataset.ctUnitBtn);
      return;
    }

    const chat = event.target.closest('[data-ct-sg-chat]');
    if (chat) {
      event.preventDefault();
      CtSg.openChat(chat.dataset.ctSgChat);
      return;
    }

    const opener = event.target.closest('[data-ct-sg-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.ctSgOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
        CtSg.syncUnitButtons();
        CtSg.publish('ct_size_drawer_open', { product: opener.dataset.product || '' });
      }
      return;
    }

    const closer = event.target.closest('[data-ct-sg-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (event.target.matches && event.target.matches('dialog.ct-sg-drawer')) {
      const r = event.target.getBoundingClientRect();
      const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) event.target.close();
    }
  });

  const ready = () => CtSg.syncUnitButtons();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', ready);

  const LABELS = {
    'corner': 'corner',
    'beside-sofa': 'spot beside the sofa',
    'entryway': 'entryway',
    'bedroom': 'bedroom',
    'office': 'home office',
    'flank-doorway': 'doorway'
  };

  class CtSgFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const src = this.querySelector('script[data-ct-sg-data]');
      try {
        this.items = JSON.parse(src ? src.textContent : '[]').filter((p) => p && p.hcm > 0);
      } catch (e) {
        this.items = [];
      }
      this.out = this.querySelector('[data-result]');
      this.tplPick = this.querySelector('template[data-tpl-pick]');
      this.tplAlt = this.querySelector('template[data-tpl-alt]');

      const params = new URLSearchParams(window.location.search);
      const d = this.dataset;
      this.state = {
        ceiling: this.valid('ceiling', params.get('ceiling')) || d.ceiling || '8',
        spot: this.valid('spot', params.get('spot')) || d.spot || 'corner',
        floor: this.valid('floor', params.get('floor')) || d.floor || 'medium',
        style: this.valid('style', params.get('style')) || 'any'
      };
      this.touched = params.has('ceiling') || params.has('spot');

      this.addEventListener('click', (event) => {
        const opt = event.target.closest('[data-step][data-value]');
        if (opt && this.contains(opt)) {
          this.state[opt.dataset.step] = opt.dataset.value;
          this.touched = true;
          this.update(true);
          return;
        }
        const add = event.target.closest('[data-add]');
        if (add) {
          this.add(add);
          return;
        }
        const link = event.target.closest('[data-pick-link]');
        if (link) {
          CtSg.publish('ct_size_finder_click', { product: link.dataset.pickLink, ...this.state });
        }
      });

      this.update(false);
    }

    valid(step, value) {
      if (!value) return null;
      return this.querySelector('[data-step="' + step + '"][data-value="' + CSS.escape(value) + '"]') ? value : null;
    }

    sync() {
      this.querySelectorAll('[data-step][data-value]').forEach((btn) => {
        btn.setAttribute('aria-pressed', this.state[btn.dataset.step] === btn.dataset.value ? 'true' : 'false');
      });
    }

    rank() {
      const s = this.state;
      const ceilIn = Number(s.ceiling) * 12;
      const lo = ceilIn - 36;
      const hi = ceilIn - 24;
      const maxW = s.floor === 'small' ? 24 : s.floor === 'medium' ? 36 : Infinity;
      const ranked = this.items.map((p) => {
        const hin = p.hin || p.hcm / 2.54;
        const win = p.wcm ? p.wcm / 2.54 : null;
        let score = hin < lo ? lo - hin : hin > hi ? (hin - hi) * 2 : 0;
        const fits = hin <= ceilIn - 12;
        if (!fits) score += 200;
        if (win && win > maxW) score += 18;
        if (!win) score += 1;
        const spots = Array.isArray(p.spots) ? p.spots : [];
        if (s.spot === 'flank-doorway') score += p.pieces > 1 ? -300 : spots.indexOf('flank-doorway') > -1 ? -20 : 25;
        else if (spots.length && spots.indexOf(s.spot) < 0) score += 6;
        if (s.style !== 'any' && p.style === s.style) score -= 10;
        if (s.spot !== 'flank-doorway' && p.pieces > 1) score += 3;
        if (hin >= lo && hin <= hi) score += (hi - hin) / 100;
        return { p, hin, win, score, fits, inRange: hin >= lo && hin <= hi, widthOk: !win || win <= maxW };
      }).sort((a, b) => a.score - b.score);
      return { ranked, lo, hi };
    }

    why(r) {
      const s = this.state;
      const p = r.p;
      const out = [];
      if (s.spot === 'flank-doorway' && p.pieces > 1) out.push('A matched pair frames a doorway evenly without crowding it.');
      else if (r.inRange) out.push('Right in the ideal height range for ' + (s.ceiling === '8' ? 'an ' : 'a ') + (s.ceiling === '10' ? '10 ft or higher' : s.ceiling + ' ft') + ' ceiling, with natural breathing room above.');
      else if (r.fits) out.push('The closest height to your ideal range, and it still leaves clear space below the ceiling.');
      else out.push('Taller than ideal for this ceiling, so check your measurements first.');
      if (r.win && r.widthOk && s.floor !== 'roomy') out.push('Its spread suits a ' + s.floor + ' footprint.');
      else if (r.win && !r.widthOk) out.push('It spreads a little wider, but the branches bend in.');
      if (s.style !== 'any' && p.style === s.style) out.push('And it has the ' + s.style.toLowerCase() + ' look you picked.');
      else if (s.spot !== 'flank-doorway' && Array.isArray(p.spots) && p.spots.indexOf(s.spot) > -1 && out.length < 2) out.push('A natural fit for a ' + (LABELS[s.spot] || s.spot) + '.');
      return out.join(' ');
    }

    fill(el, sel, value) {
      const node = el.querySelector(sel);
      if (!node) return null;
      if (value instanceof Node) {
        node.textContent = '';
        node.append(value);
      } else if (value == null || value === '') {
        node.remove();
        return null;
      } else {
        node.textContent = value;
      }
      return node;
    }

    image(holder, p) {
      if (!holder) return;
      if (!p.image) {
        const fig = this.querySelector('template[data-fig="' + CSS.escape(p.handle) + '"]');
        if (fig) {
          holder.append(fig.content.cloneNode(true));
          return;
        }
      }
      const src = p.image || p.silhouette;
      if (!src) return;
      const img = document.createElement('img');
      img.src = src;
      img.alt = p.imageAlt || p.title;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 600;
      img.height = 800;
      if (p.image && !p.imageContain) img.dataset.fit = 'cover';
      holder.append(img);
    }

    pickCard(r) {
      const p = r.p;
      const node = this.tplPick.content.firstElementChild.cloneNode(true);
      const media = node.querySelector('[data-media]');
      if (media) {
        media.href = p.url;
        this.image(media, p);
        media.dataset.pickLink = p.handle;
      }
      const tag = node.querySelector('[data-tag]');
      if (tag) tag.textContent = r.inRange || (this.state.spot === 'flank-doorway' && p.pieces > 1) ? tag.dataset.best : tag.dataset.close;
      const name = node.querySelector('[data-name]');
      if (name) {
        name.textContent = p.title;
        name.href = p.url;
        name.dataset.pickLink = p.handle;
      }
      const specs = node.querySelector('[data-specs]');
      if (specs) {
        const li = (label, frag) => {
          const item = document.createElement('li');
          const b = document.createElement('b');
          b.append(frag);
          item.append(b, document.createTextNode(' ' + label));
          specs.append(item);
        };
        li('tall', CtSg.height(p.hcm, p.hin));
        if (p.wcm) li('wide', CtSg.width(p.wcm));
        if (p.pieces > 1) {
          const item = document.createElement('li');
          item.textContent = 'Set of ' + p.pieces;
          specs.append(item);
        }
      }
      this.fill(node, '[data-why]', this.why(r));
      const price = node.querySelector('[data-price]');
      if (price) {
        price.textContent = p.price || '';
        if (p.compare) {
          const s = document.createElement('s');
          s.textContent = p.compare;
          price.append(s);
        }
      }
      const view = node.querySelector('[data-view]');
      if (view) {
        view.href = p.url;
        view.dataset.pickLink = p.handle;
      }
      const add = node.querySelector('[data-add]');
      if (add) {
        if (p.variant && p.available) {
          add.dataset.add = p.variant;
          add.dataset.handle = p.handle;
        } else {
          add.disabled = true;
          add.textContent = add.dataset.soldOut || 'Sold out';
        }
      }
      const bundle = node.querySelector('[data-bundle]');
      if (bundle && p.pieces > 1) bundle.remove();
      return node;
    }

    altRow(r) {
      const p = r.p;
      const node = this.tplAlt.content.firstElementChild.cloneNode(true);
      node.href = p.url;
      node.dataset.pickLink = p.handle;
      this.image(node.querySelector('[data-media]'), p);
      this.fill(node, '[data-name]', p.title);
      const meta = node.querySelector('[data-meta]');
      if (meta) {
        meta.append(CtSg.height(p.hcm, p.hin));
        meta.append(document.createTextNode(r.inRange ? ' · In range' : r.fits ? ' · Fits' : ' · Tall for this ceiling'));
      }
      return node;
    }

    update(user) {
      this.sync();
      const { ranked, lo, hi } = this.rank();
      const range = this.querySelector('[data-range]');
      if (range) {
        range.textContent = '';
        range.append(CtSg.dual((lo / 12) + '–' + (hi / 12) + ' ft', Math.round(lo * 2.54) + '–' + Math.round(hi * 2.54) + ' cm'));
      }
      if (!this.out) return;
      this.out.textContent = '';
      if (!ranked.length || !this.tplPick) {
        const empty = document.createElement('p');
        empty.className = 'ct-sg-finder__empty';
        empty.textContent = this.dataset.empty || 'Add height details to your trees to see recommendations.';
        this.out.append(empty);
        return;
      }
      const main = ranked[0];
      this.out.append(this.pickCard(main));
      const doorPair = this.state.spot === 'flank-doorway' && main.p.pieces > 1;
      if (!main.inRange && !doorPair && this.dataset.note) {
        const note = document.createElement('p');
        note.className = 'ct-sg-pick__note';
        note.textContent = this.dataset.note;
        this.out.append(note);
      }
      const alts = ranked.slice(1, 1 + Number(this.dataset.alts || 2)).filter((r) => r.fits);
      if (alts.length && this.tplAlt) {
        const box = document.createElement('div');
        box.className = 'ct-sg-finder__alts';
        const h = document.createElement('p');
        h.className = 'ct-sg-finder__alts-h';
        h.textContent = this.dataset.altsLabel || 'Also a good fit';
        box.append(h);
        alts.forEach((r) => box.append(this.altRow(r)));
        this.out.append(box);
      }

      if (user) {
        const url = new URL(window.location.href);
        url.searchParams.set('ceiling', this.state.ceiling);
        url.searchParams.set('spot', this.state.spot);
        url.searchParams.set('floor', this.state.floor);
        if (this.state.style !== 'any') url.searchParams.set('style', this.state.style);
        else url.searchParams.delete('style');
        try {
          history.replaceState(history.state, '', url.toString());
        } catch (e) {}
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          CtSg.publish('ct_size_finder_result', { ...this.state, product: main.p.handle, in_range: main.inRange });
        }, 600);
      }
    }

    async add(btn) {
      const id = Number(btn.dataset.add);
      if (!id) return;
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.dataset.adding || 'Adding…';
      try {
        await CtSg.addToCart(btn, [{ id: id, quantity: 1 }]);
        btn.textContent = btn.dataset.added || 'Added';
        CtSg.publish('ct_size_finder_add', { product: btn.dataset.handle, variant: id, ...this.state });
        setTimeout(() => {
          btn.textContent = label;
          btn.disabled = false;
        }, 2200);
      } catch (err) {
        btn.textContent = label;
        btn.disabled = false;
        const msg = this.querySelector('[data-error]');
        if (msg) {
          msg.textContent = err.message;
          msg.hidden = false;
        }
      }
    }
  }

  class CtSgCompare extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.stage = this.querySelector('[data-stage]');
      this.addEventListener('click', (event) => {
        const ceil = event.target.closest('[data-ceil]');
        if (ceil) {
          this.querySelectorAll('[data-ceil]').forEach((b) => b.setAttribute('aria-pressed', b === ceil ? 'true' : 'false'));
          if (this.stage) this.stage.style.setProperty('--ceil', ceil.dataset.ceil);
          const label = this.querySelector('[data-ceil-label]');
          const src = ceil.querySelector('[data-label]');
          if (label && src) label.innerHTML = src.innerHTML;
          return;
        }
        const tree = event.target.closest('[data-tree]');
        if (tree) this.select(tree.dataset.tree, true);
      });
      const first = this.querySelector('[data-tree][aria-pressed="true"]') || this.querySelector('[data-tree]');
      if (first) this.select(first.dataset.tree, false);
    }

    select(id, user) {
      this.querySelectorAll('[data-tree]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.tree === id ? 'true' : 'false'));
      this.querySelectorAll('[data-panel]').forEach((p) => {
        p.hidden = p.dataset.panel !== id;
      });
      if (user) CtSg.publish('ct_size_compare_select', { product: id });
    }
  }

  if (!customElements.get('ct-sg-finder')) customElements.define('ct-sg-finder', CtSgFinder);
  if (!customElements.get('ct-sg-compare')) customElements.define('ct-sg-compare', CtSgCompare);
})();
